import { render } from "./SuperAdminDashboard.vue?vue&type=template&id=2b0332dd&scoped=true"
import script from "./SuperAdminDashboard.vue?vue&type=script&lang=js"
export * from "./SuperAdminDashboard.vue?vue&type=script&lang=js"

import "./SuperAdminDashboard.vue?vue&type=style&index=0&id=2b0332dd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b0332dd"]])

export default __exports__